import { ActionTree } from 'vuex';

export default class SimpleDataModule {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly defaultDataValue?,
    private readonly defaultParams? // eslint-disable-next-line no-empty-function
  ) {}

  namespaced = true;

  state = {
    loading: false,
    data: this.defaultDataValue,
    params: this.defaultParams,
    error: null,
  };

  getters = {
    data: (state) => state.data,
    params: (state) => state.params,
    loading: (state) => state.loading,
    error: (state) => state.error,
  };

  mutations = {
    SET_PARAMS: (state, val) => {
      state.params = val;
    },
    SET_DATA: (state, values) => {
      state.data = values;
      state.loading = false;
    },
    SET_ERROR: (state, values) => {
      state.error = values;
      state.loading = false;
    },
    SET_LOADING: (state) => {
      state.data = this.defaultDataValue;
      state.loading = true;
    },
  };

  actions?: ActionTree<any, any>;
}
